import { useLocation } from "react-router-dom";
import Image1 from "../assets/images/Group 82.webp";
import Image2 from "../assets/images/mock-gcb 1.webp";
import Image3 from "../assets/images/visaya 1.webp";
import Image4 from "../assets/images/mock-itechlabs 2.webp";
import Image5 from "../assets/images/foote-cert.webp";
import Image6 from "../assets/images/mock-threatmetrix.webp";
import Image7 from "../assets/images/tng.webp";
import Image8 from "../assets/images/grab.webp";
import Image9 from "../assets/images/fpx.webp";
import Image10 from "../assets/images/duitnow.webp";
import { Link } from "react-router-dom";
import SocialIcons from "./social-icons"; // Assuming you have a SocialIcons component
import RouteMap from "config/RouteMap";
import { isMobile } from "react-device-detect";
import _CONFIG_ from "config/Constant";

export default function Footer() {
  const { pathname } = useLocation();

  function isMob() {
    if (
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i)
    ) {
      return true;
    } else {
      return false;
    }
  }
  function isTab() {
    if (
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i)
    ) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <>
      {isMobile ? (
        <div id="footer-btns">
          <a
            href={_CONFIG_.REGISER_URL}
            className="btn-login"
            rel="noopener nofollow"
          >
            Login
          </a>
          <a href={_CONFIG_.REGISER_URL} rel="noopener nofollow">
            Register
          </a>
        </div>
      ) : null}

      <footer>
        <div className="container">
          <div className="row no-gutter flex-row">
            <div className="foot-cols">
              <p className="h4">About Us</p>
              <div className="foot-col-content">
                <p>
                  Hengongbet is Malaysia’s trusted online gaming platform,
                  offering a wide range of sports betting, slots, and live
                  games. With a secure system, seamless gameplay, and 24/7
                  support, we deliver excitement and reliability for every
                  player. Join Hengongbet today for entertainment you can trust.
                </p>
              </div>
            </div>
            <div className="foot-cols">
              <p className="h4">GAMES</p>
              <div className="footer-menu">
                <ul className="foot-col-content flex flex-dir-col g-10">
                  <li>
                    <Link to={RouteMap.slots}>Slots</Link>
                  </li>
                  <li>
                    <Link to={RouteMap.liveCasino}>Live Casino</Link>
                  </li>
                  <li>
                    <Link to={RouteMap.sports}>Sports</Link>
                  </li>
                  <li>
                    <Link to={RouteMap.lottery}>Lottery</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="foot-cols">
              <p className="h4">CERT & LICENSE</p>
              <div className="footer-menu">
                <ul className="foot-col-content flex flex-dir-col g-10">
                  <li>
                    <a
                      href={`${process.env.PUBLIC_URL}/certs-license/gli--asia-football-stars.pdf`}
                    >
                      GLI Certificate
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${process.env.PUBLIC_URL}/certs-license/egld-426-eg-form-no-9-new-system-game-machine-request.pdf`}
                    >
                      PAGCOR Approval Form
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${process.env.PUBLIC_URL}/certs-license/joint-certification-qnx-3oct24.pdf`}
                    >
                      Joint Certification
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="foot-cols">
              <p className="h4">HELP</p>
              <div className="footer-menu">
                <ul className="foot-col-content flex flex-dir-col g-10">
                  <li>
                    <Link to={RouteMap.help}>Help</Link>
                  </li>
                  <li>
                    <Link to={RouteMap.download}>Download</Link>
                  </li>
                  <li>
                    <Link to={RouteMap.login}>Login</Link>
                  </li>
                  <li>
                    <Link to={RouteMap.register}>Register</Link>
                  </li>
                  <li>
                    <Link to={RouteMap.shareholder}>Shareholder</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="foot-cols">
              <p className="h4">FOLLOW US</p>
              <div className="flex foot-col-content g-10 justify-center">
                <a href="#" target="_blank">
                  <SocialIcons.FB />
                </a>
                <a href="#" target="_blank">
                  <SocialIcons.TW />
                </a>
                <a href="#" target="_blank">
                  <SocialIcons.IG />
                </a>
                <a href="#" target="_blank">
                  <SocialIcons.TG />
                </a>
                <a href="#" target="_blank">
                  <SocialIcons.YT />
                </a>
              </div>
            </div>
          </div>
          <div className="row no-gutter flex-row mt-40">
            <div className="foot-cols">
              <p className="h4">GAMING LICENSE</p>
              <div className="flex foot-col-content g-10 justify-center">
                <img src={Image1} loading="lazy" alt="Paggor GAMING LICENSE" />
                <img src={Image2} loading="lazy" alt="Gcb Gaming License" />
              </div>
            </div>
            <div className="foot-cols">
              <p className="h4">CERTIFICATIONS</p>
              <div className="flex foot-col-content g-10 justify-center">
                <img src={Image3} loading="lazy" alt="Visaya CERTIFICATIONS" />
                <img src={Image4} loading="lazy" alt="Mock Itechlabs Certifications" />
                <img src={Image5} loading="lazy" alt="Foote Cert Certifications" />
              </div>
            </div>
            <div className="foot-cols">
              <p className="h4">SECURITY</p>
              <div className="flex foot-col-content g-10 justify-center">
                <img src={Image6} loading="lazy" alt="Mock Threatmetrix Security" />
              </div>
            </div>
            <div className="foot-cols">
              <p className="h4">PAYMENT METHOD</p>
              <div className="flex foot-col-content g-10 justify-center">
                <img src={Image7} loading="lazy" alt="Tng PAYMENT METHOD" />
                <img src={Image8} loading="lazy" alt="Grab Pay Payment Method" />
                <img src={Image9} loading="lazy" alt="Fpx Payment Method" />
                <img src={Image10} loading="lazy" alt="Duit Now Payment Method" />
              </div>
            </div>
          </div>
          <div className="row no-gutter justify-center mt-30">
            <p className="copy-right">
              Copyright © 2025 i1hengongbet. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </>
  );
}
